import { render, staticRenderFns } from "./segmentedAccessoryOrders.vue?vue&type=template&id=98974e98&"
import script from "./segmentedAccessoryOrders.vue?vue&type=script&lang=js&"
export * from "./segmentedAccessoryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports